import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environments';

@Injectable({ providedIn: 'root' })
export class RoomService {

    private subject = new BehaviorSubject<string>('Initial Value')
    current = this.subject.asObservable()

    private arrayData = new BehaviorSubject([])
    currentArray = this.arrayData.asObservable()

    constructor(
        private router: Router,
        private http: HttpClient
    ) { }


    addRoomServiceCategory(name: any, image: any) {
        var formData = {
            'name': name,
            'image': image,
        }
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/apartment/room-service/category/add`, formData).pipe(map(user => {
            return user;
        }));
    }

    upadteRoomServiceCategory(id: any, name: any, image: any) {
        var formData = {
            'name': name,
            'image': image,
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/apartment/room-service/category/update/${id}`, formData).pipe(map(user => {
            return user;
        }));
    }
    getServiceCategorylistbyId(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/apartment/room-service/category/list/${id}`).pipe(map(user => user));
    }
    deleteServiceCategory(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/apartment/room-service/category/delete/` + id)
            .pipe(map((user) => {
                return user;
            }));
    }
    getServiceCategoryList(page: any, search: any, status: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/apartment/room-service/category/list?search=` + search + '&page=' + page + '&status=' + status).pipe(map(user => user));
    }

    getRoomeServiceCategoryDropDown() {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/apartment/room-service/category/dropdown`).pipe(map(user => user));
    }


    blockRoom(id: any, status: any) {
        let formData =
        {
            'status': status
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/apartment/room-service/category/update/${id}`, formData).pipe(map(user => {
            return user;
        }));
    }

    // Sub-category
    addRoomServicesubCategory(name: any, serviceCategoryId: any, maxPurchase: any, price: any, isFree: any) {
        var formData = {
            'name': name,
            'serviceCategoryId': serviceCategoryId,
            'maxPurchase': maxPurchase,
            'price': price,
            'isFree': isFree
        }
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/apartment/room-service/items/add`, formData).pipe(map(user => {
            return user;
        }));
    }

    upadteRoomServicesubCategory(id: any, name: any, serviceCategoryId: any, maxPurchase: any, price
        : any, isFree: any, status: any
    ) {
        var formData = {
            'name': name,
            'serviceCategoryId': serviceCategoryId,
            'maxPurchase': maxPurchase,
            'price': price,
            'isFree': isFree,
            status: status
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/apartment/room-service/items/update/${id}`, formData).pipe(map(user => {
            return user;
        }));
    }
    blockSubCategoryRoom(id: any, status: any) {
        let formData =
        {
            'status': status
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/apartment/room-service/items/update/${id}`, formData).pipe(map(user => {
            return user;
        }));
    }
    getRoomServiceItemlistbyId(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/apartment/room-service/items/view/${id}`).pipe(map(user => user));
    }

    getRoomServicesubCategoryList(page: any, search: any, status: any, isFree: any, serviceCategoryId: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/apartment/room-service/items/list?search=` + search + '&page=' + page + '&status=' + status + '&isFree=' + isFree + '&serviceCategoryId=' + serviceCategoryId).pipe(map(user => user));
    }

    getRoomServicesubCategoryDropDown(categoryId: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/laundry/sub-category/dropdown?categoryId=` + categoryId).pipe(map(user => user));
    }


    // RoomService Order
    RoomorderDetails(orderStatus: any, search: any, page: any, fromDate: any, toDate: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/roomservice/list?orderStatus=` + orderStatus + '&search=' + search + '&page=' + page + '&fromDate=' + fromDate + '&toDate=' + toDate).pipe(map(user => user));
    }

    RoomordeRDetails(orderStatus: any, search_invoiceNumber: any, search_userName: any, search_userContactNo: any, search_userEmail: any, page: any, fromDate: any, toDate: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/roomservice/list?orderStatus=` + orderStatus + '&search_invoiceNumber=' + search_invoiceNumber + '&search_userName=' + search_userName + '&search_userContactNo=' + search_userContactNo + '&search_userEmail=' + search_userEmail+ '&page=' + page + '&fromDate=' + fromDate + '&toDate=' + toDate).pipe(map(user => user));
    }

    updateRoomOrderStatus(id: any, orderStatus: any, rejectedReason: any) {
        var formData = {
            'orderStatus': orderStatus,
            'rejectedReason': rejectedReason
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/roomservice/update-status/${id}`, formData).pipe(map(user => {
            return user;
        }));
    }

    settelmentDetails(paidStatus: any, search_invoiceNumber: any, search_userName: any, search_userContactNo: any, search_userEmail: any, page: any, fromDate: any, toDate: any,driverId: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/apartment/settlement/list?paidStatus=` + paidStatus + '&search_invoiceNumber=' + search_invoiceNumber + '&search_userName=' + search_userName + '&search_userContactNo=' + search_userContactNo + '&search_userEmail=' + search_userEmail+ '&page=' + page + '&fromDate=' + fromDate + '&toDate=' + toDate + '&driverId=' + driverId).pipe(map(user => user));
    }

    paidUpdate(id: any) {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/apartment/settlement/settlement/${id}`,{});
    }

     getDriverDropdown() {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/apartment/staff/dropdown?isDriver=` + 1).pipe(map(user => user));
    }

    getNewRoomOrderCount() {
        return this.http
            .get<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/roomservice/count`
            )
            .pipe(map((user) => user));
    }
    getRoomOrderDetailsByID(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/roomservice/viewById/${id}`).pipe(map(user => user));
    }

    billtodeskorderDetails(search: any, page: any,status:any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/billToDesk/list?search=` + search + '&page=' + page +'&billToDeskPaid='+status).pipe(map(user => user));
    }

    getbilltodeskById(id: string): Observable<any> {
        return this.http.get<any>(
            `${environment.apiUrl}${environment.apiPrefix}/admin/billToDesk/view/${id}`
        ).pipe(map(res => res));
    }

    getBillToDeskCount() {
        return this.http
            .get<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/billToDesk/count`
            )
            .pipe(map((user) => user));
    }

    getRatingsList(search: string, page: number, orderType: string = '', rating: string = '') {
        return this.http
            .get<any>(
                `${environment.apiUrl}${environment.apiPrefix}/apartment/rating/list?search=${search}&page=${page}&orderType=${orderType}&deliveryRating=${rating}`
            );
    }

    updateOrderStatus(id: any, orderStatus: any, deliveryDate: any, deliveryTime: any
    ) {
        var formData = {
            'orderStatus': orderStatus,
            'deliveryDate': deliveryDate,
            'deliveryTime': deliveryTime
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/roomservice/update-status/${id}`, formData).pipe(map(user => {
            return user;
        }));
    }

    getDriverList(): Observable<any> {
        return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/apartment/driver/list`);
    }

    updateOrderStatusOnly(orderId: string,orderStatus: number,deliveryDate: any, deliveryTime: any): Observable<any> {
        const payload = {
            orderStatus: orderStatus,
         
            deliveryDate: deliveryDate,
            deliveryTime: deliveryTime
        };
        return this.http.put(`${environment.apiUrl}${environment.apiPrefix}/admin/roomservice/update-status/${orderId}`, payload);
    }

    assignAndAccept(orderId: string,driver_id: any,accepted_status: any): Observable<any> {
        const payload = {
            order_id: orderId,
         
            driver_id: driver_id,
            accepted_status: accepted_status
        };
        return this.http.put(`${environment.apiUrl}${environment.apiPrefix}/admin/roomservice/update-accepted-status`, payload);
    }

    //assign-driver
    assignAllDrivers(orderId: string, driverIds: string[]): Observable<any> {
    const payload = {
      order_id: orderId,
      assigned_driver: driverIds
    };
    return this.http.put(`${environment.apiUrl}${environment.apiPrefix}/admin/roomservice/assign-drivers`, payload);
  }

    // Additional Order
    AdditionalorderDetails(orderStatus: any, search: any, page: any, fromDate: any, toDate: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/roomservice-additional/list?orderStatus=` + orderStatus + '&search=' + search + '&page=' + page + '&fromDate=' + fromDate + '&toDate=' + toDate).pipe(map(user => user));
    }
    updateAdditionalOrderStatus(id: any, orderStatus: any, rejectedReason: any) {
        var formData = {
            'orderStatus': orderStatus,
            'rejectedReason': rejectedReason
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/roomservice-additional/update-status/${id}`, formData).pipe(map(user => {
            return user;
        }));
    }
    getNewAdditionalOrderCount() {
        return this.http
            .get<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/roomservice-additional/count`
            )
            .pipe(map((user) => user));
    }
    getAdditionalOrderDetailsByID(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/roomservice-additional/viewById/${id}`).pipe(map(user => user));
    }

    updateAdDitionalOrderStatus1(id: any, orderStatus: any, deliveryDate: any, deliveryTime: any
    ) {
        var formData = {
            'orderStatus': orderStatus,
            'deliveryDate': deliveryDate,
            'deliveryTime': deliveryTime
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/roomservice-additional/update-status/${id}`, formData).pipe(map(user => {
            return user;
        }));
    }

    // Get permission - Staff
    getStaffUsers(page: any, search: any, status: any) {
        return this.http
            .get<any>(
                `${environment.apiUrl}${environment.apiPrefix}/apartment/staff/list?page=` +
                page +
                "&search=" +
                search +
                "&status=" +
                status
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    createStaff(formData: FormData) {
        return this.http
            .post<any>(
                `${environment.apiUrl}${environment.apiPrefix}/apartment/staff/add`,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    deleteStaffUser(id: any) {
        return this.http
            .delete<any>(
                `${environment.apiUrl}${environment.apiPrefix}/apartment/staff/delete/` +
                id
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    viewStaffUsersbyId(id: any) {
        return this.http
            .get<any>(
                `${environment.apiUrl}${environment.apiPrefix}/apartment/staff/viewById/` +
                id
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }
    updatepassword(id: any, newPassword: any, confirmPassword: any) {
        const formData = {
            newPassword: newPassword,
            confirmPassword: confirmPassword
        };
        return this.http
            .put<any>(
                `${environment.apiUrl}${environment.apiPrefix}/apartment/staff/update-password/` +
                id,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }
    updateStaff(id: any,formData: FormData) {
        return this.http
            .put<any>(
                `${environment.apiUrl}${environment.apiPrefix}/apartment/staff/update/` +
                id,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    blockStaffUser(id: any, name: any, username: any, status: any) {
        let formData =
        {
            name: name,
            username: username,
            status: status
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/apartment/staff/update/` + id, formData)
            .pipe(map((user) => {
                return user;
            }));
    }

    // Excel

    categoryExcelUpload(file: any) {
        const formData = new FormData();
        formData.append("file", file);
        return this.http
            .post<any>(
                `${environment.apiUrl}${environment.apiPrefix}/apartment/room-service/excel/categoryUpload`,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    downloadCategoryExcel() {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/apartment/room-service/excel/categoryexcelDownload`,
                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }


    ItemExcelUpload(file: any) {
        const formData = new FormData();
        formData.append("file", file);
        return this.http
            .post<any>(
                `${environment.apiUrl}${environment.apiPrefix}/apartment/room-service/excel/itemUpload`,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    downloadItemExcel() {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/apartment/room-service/excel/itemExcel`,
                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }

    // report
    RoomServiceReport(page: any, search: any, startDate: any, endDate: any, apartmentId: any, categoryId: any,itemId:any) {
        return this.http
            .get<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/reports/room-service/item-report?page=` +
                page +
                "&search=" +
                search +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&apartmentId=" +
                apartmentId +
                "&categoryId=" +
                categoryId +
                "&itemId="
                +itemId
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );

    }
    downloadRoomServiceGenerationExcel(startDate: any, endDate: any, apartmentId: any, categoryId: any,itemId:any) {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/excel-reports/room-service/item-report?startDate=` +
                startDate +
                "&endDate=" +
                endDate +
                "&apartmentId=" +
                apartmentId +
                "&categoryId=" +
                categoryId +
                "&itemId="
                +itemId,
                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }
    downloadroomserviceExcel(startDate: any, endDate: any) {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/apartment/room-service/excel/downloadDeliveredOrd?startDate=` +
                startDate +
                "&endDate=" +
                endDate,

                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }

    // Status Change
    apartmentStatusChange(status: any) {
        let formData =
        {
            'status': status
        }
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/apartment/statusUpdate`, formData).pipe(map(user => {
            return user;
        }));
    }
    downloadApartmentdeliveryExeclFormat(fromDate: any, toDate: any, search: any) {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/apartment/room-service/excel/downloadDeliveredOrd?fromDate=` +
                fromDate +
                "&toDate=" +
                toDate +
                "&search="
                + search,

                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }



    getApartmentItemDropdown(categoryId: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/apartment/room-service/items/dropdown?categoryId=` + categoryId).pipe(map(user => user));
    }

    // Residential Service Report APIs
    getResidentialCategoryDropdown(apartmentId: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/reports/residential-service/category-dropdown?apartmentId=` + apartmentId).pipe(map(user => user));
    }

    getResidentialItemDropdown(apartmentId: any, categoryId: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/reports/residential-service/item-dropdown?apartmentId=` + apartmentId + '&categoryId=' + categoryId).pipe(map(user => user));
    }

    getResidentialReport(page: any, search: any, startDate: any, endDate: any, apartmentId: any, categoryId: any, itemId: any) {
        return this.http.get<any>(
            `${environment.apiUrl}${environment.apiPrefix}/admin/reports/residential-service/item-report?page=` +
            page + '&search=' + search + '&startDate=' + startDate + '&endDate=' + endDate +
            '&apartmentId=' + apartmentId + '&categoryId=' + categoryId + '&itemId=' + itemId
        ).pipe(map(user => user));
    }

    downloadResidentialItemReportExcel(startDate: any, endDate: any, apartmentId: any, categoryId: any, itemId: any, search: any) {
        return this.http.get<Blob>(
            `${environment.apiUrl}${environment.apiPrefix}/admin/reports/residential-service/item-report/download?apartmentId=` +
            apartmentId + '&categoryId=' + categoryId + '&search=' + search + '&itemId=' + itemId +
            '&startDate=' + startDate + '&endDate=' + endDate,
            { responseType: 'blob' as 'json' }
        ).pipe(map(user => user));
    }

    downloadResidentialCompletedOrdersExcel(startDate: any, endDate: any, apartmentId: any, search: any) {
        return this.http.get<Blob>(
            `${environment.apiUrl}${environment.apiPrefix}/admin/reports/residential-service/completed-orders/download?apartmentId=` +
            apartmentId + '&search=' + search + '&startDate=' + startDate + '&endDate=' + endDate,
            { responseType: 'blob' as 'json' }
        ).pipe(map(user => user));
    }

    paidStatusUpdate(id: any,useWallet : boolean) {
        var formData = {
            'parentId': id,
            'useWallet': useWallet
        }
        return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/billToDesk/paidStatusUpdate`, formData).pipe(map(user => {
            return user;
        }));
    }
}